import { MdEdit, MdContentCopy } from 'react-icons/md';
import './ListagemInfoLicenca.css';
import Tooltip from '../Tooltip/Tooltip';
import StatusLicenca from '../StatusLicenca/StatusLicenca';
import NotificacaoUtils from '../../utils/NotificacaoUtils';
import BotaoEditar from '../BotaoEditar/BotaoEditar';
import FormatacaoUtils from '../../utils/FormatacaoUtils';
import Mensagens from '../../utils/MensagemUtils';

const ListagemInfoLicenca = ({ 
  informacoesLicenca,
  onClickEditar,
  exibeEditarPadrao = true,
  exibeCopiarUnidade = true,
  exibeEditar = true,
  exibeSituacao = true,
}) => {

  const handleCopy = text => {
    navigator.clipboard.writeText(text)
      .then(() => NotificacaoUtils.sucesso(Mensagens.CLIENTE.LICENCA.COPIAR_UNIDADE_SUCESSO))
      .catch(() => NotificacaoUtils.erro(Mensagens.CLIENTE.LICENCA.COPIAR_UNIDADE_ERRO));
  };

  return (
    <div className="listagem-info-licenca">
      {informacoesLicenca.map(info => (
        <div key={info.id || info.nome} className="card-licenca">
          <div className="header-licenca">
            <div className="info-licenca">
              <h3>
                {exibeEditar && <BotaoEditar onClick={onClickEditar} info={info} />}
                {info.planoDTO.descricaoTipoSistema}
                {exibeEditarPadrao && (
                  <Tooltip text="Editar licença">
                    <MdEdit className="icone-licenca" onClick={() => onClickEditar(info)} />
                  </Tooltip>
                )}
              </h3>
              <div className="unidade-info">
                <span className="label">Unidade:</span>
                <span className="value">{info.unidade}</span>
                {exibeCopiarUnidade && (
                  <Tooltip text="Copiar unidade">
                    <MdContentCopy
                      className="icone-copiar"
                      onClick={() => handleCopy(info.unidade)}
                    />
                  </Tooltip>
                )}
              </div>
            </div>
            <div className="status-licenca">
              <StatusLicenca cancelado={info.cancelado} expirado={info.expirado} />
            </div>
          </div>

          <hr className="divisor" />

          <div className="detalhes-licenca">
            <div className="item-licenca">
              <span className="label">Plano</span>
              <span className="value">{info.planoDTO.descricao}</span>
            </div>

            {info.limites.map((limite, idx) => (
              <div key={limite.id || `${limite.descricao}-${idx}`} className="item-licenca">
                <span className="label">{limite.descricao}</span>
                <span className="value">{`${limite.utilizado} / ${limite.max}`}</span>
              </div>
            ))}

            <div className="item-licenca">
              <span className="label">Inclusão</span>
              <span className="value">{info.dataInclusao}</span>
            </div>
            <div className="item-licenca">
              <span className="label">Expiração</span>
              <span className="value">{FormatacaoUtils.formatarData(info.dataExpiracao)}</span>
            </div>
            {info.dataCancelamento && info.dataCancelamento.includes('/') && (
              <div className="item-licenca">
                <span className="label">Cancelamento</span>
                <span className="value">{info.dataCancelamento}</span>
              </div>
            )}

            {exibeSituacao && (
              <div className="item-licenca">
                <span className="label">Situação</span>
                <span className="value">{(info.situacaoCadastro === true || (typeof info.situacaoCadastro === 'string' && info.situacaoCadastro.toLowerCase() === 'ativo')) ? 'ATIVO' : 'INATIVO'}</span>
              </div>
            )}
            {info.acessoSuporte !== undefined && (
              <div className="item-licenca">
                <span className="label">Acesso Suporte</span>
                <span className="value">
                  {typeof info.acessoSuporte === 'string' 
                    ? info.acessoSuporte 
                    : (info.acessoSuporte === true ? 'Sim' : 'Não')}
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListagemInfoLicenca;